<script setup>
import ClassicAuthCard from '../components/ClassicAuthCard.vue'

defineProps({
  identifier: { type: String, required: true },
  loading: { type: Boolean, default: false },
  error: { type: String, default: '' },
  feedback: { type: String, default: '' },
  isCoolingDown: { type: Boolean, default: false },
  countdown: { type: String, default: '' },
  registerUrl: { type: String, default: '/register' },
})

defineEmits(['resend'])
</script>

<template>
  <ClassicAuthCard title="Reset Password" :register-url="registerUrl">
    <div class="classic-sent">
      <p class="classic-sent__status" role="status">
        {{ feedback || 'We have emailed your password reset link.' }}
      </p>

      <label class="classic-sent__label" for="classic-reset-sent-email">
        Email *
      </label>
      <input id="classic-reset-sent-email" class="classic-sent__input" type="email" :value="identifier" readonly>

      <p v-if="error" class="classic-sent__error" role="alert">{{ error }}</p>

      <button
        class="classic-sent__submit"
        type="button"
        :disabled="loading || isCoolingDown"
        @click="$emit('resend')"
      >
        {{ loading ? 'Please wait…' : isCoolingDown ? `Send again in ${countdown}` : 'Send Password Reset Link' }}
      </button>
    </div>
  </ClassicAuthCard>
</template>

<style scoped>
.classic-sent { display: flex; flex-direction: column; }
.classic-sent__status { background: #d4edda; border: 1px solid #c3e6cb; border-radius: 4px; color: #155724; font-size: 14px; line-height: 1.5; margin: 0 0 22px; padding: 12px 16px; }
.classic-sent__label { color: #333; font-size: 14px; font-weight: 600; margin-bottom: 8px; }
.classic-sent__input { background: transparent; border: 0; border-bottom: 1px solid #c6c6c6; border-radius: 0; box-sizing: border-box; color: #7c7c7c; font: inherit; min-height: 46px; padding: 10px 0; width: 100%; }
.classic-sent__error { color: #dc3545; font-size: 13px; margin: 8px 0 0; }
.classic-sent__submit { align-self: center; background: #ff7f5d; border: 0; border-radius: 25px; color: #fff; cursor: pointer; font: inherit; font-weight: 500; margin-top: 28px; min-width: 260px; padding: 12px 20px; }
.classic-sent__submit:disabled { cursor: not-allowed; opacity: 0.6; }
</style>
